import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import moment from 'moment/src/moment'

export default function substituteSimCardProducts () {
  return {
    data () {
      return {
        substituteSimCardProducts: {
          substituteSimCardFree: {
            latestOrderDate: null,
            remainingPeriod: 0,
            totalPeriod: 0
          }
        },
        loadedSimCardProducts: false,
        error: {}
      }
    },
    computed: {
      substituteSimCardFree () {
        return this.substituteSimCardProducts?.substituteSimCardFree
      },
      freeSimReplacementDaysLeft () {
        return this.substituteSimCardFree?.remainingPeriod || 0
      },
      freeSimReplacementLastDate () {
        return this.substituteSimCardFree?.latestOrderDate
      },
      formattedFreeSimReplacementLastDate () {
        if (!this.freeSimReplacementLastDate) {
          return ''
        }
        return moment(this.freeSimReplacementLastDate).format('DD.MM.YYYY')
      },
      isEsimFree () {
        return this.loadedSimCardProducts && this.substituteSimCardFree?.remainingPeriod > 0
      }
    },
    apollo: {
      substituteSimCardProducts: function () {
        return wrapQuery(gql`
          query substituteSimCardFree {
            substituteSimCardProducts {
              substituteSimCardFree {
                latestOrderDate
                remainingPeriod
                totalPeriod
              }
            }
          }`, this, 'substituteSimCardProducts', {}, () => {
          this.loadedSimCardProducts = true
        },
        {},
        (error) => {
          this.error = error
        })
      }
    }
  }
}
